import DriverApp from '../driver/App'

import DriverSessions from '../driver/pages/sessions/Index'

/** 初期パスワード変更 */
import DriverInitialPasswordEdit from '../driver/pages/initial_password/Edit'

/** パスワード忘れ */
import DriverForget from '../driver/pages/forget/Index'
import DriverForgetEdit from '../driver/pages/forget/Edit'
import DriverForgetCompleted from '../driver/pages/forget/Completed'

/** ダッシュボード */
import DriverDashboard from '../driver/pages/dashboard/Index'

/** 受注一覧2.0  */
import DriverOrderAccepts from '../driver/pages/orders/accepts/Index'

/** 受注 回収新規 */
import DriverOrderAcceptCollectionNew from '../driver/pages/orders/accepts/collection/New'

/** 受注 回収複写新規 */
import DriverOrderAcceptCollectionDuplicate from '../driver/pages/orders/accepts/collection/Duplicate'

/** 受注 詳細 */
import DriverOrderAcceptCollection from '../driver/pages/orders/accepts/collection/Show'

/** 受注 回収編集 */
import DriverOrderAcceptCollectionEdit from '../driver/pages/orders/accepts/collection/Edit'

/** 受注 産廃回収からの受注登録 */
import DriverOrderAcceptCollectionRegistrationEdit from '../driver/pages/orders/accepts/collection/registrations/Edit'

/** 排出自己運搬  */
import DriverOrderAcceptSelfEmissionRegistrationEdit from '../driver/pages/orders/accepts/self_emissions/registrations/Edit'

/** 受注 自己運搬新規 */
import DriverOrderAcceptSelfEmissionNew from '../driver/pages/orders/accepts/self_emissions/New'

/** 受注 自己運搬詳細 */
import DriverOrderAcceptSelfEmission from '../driver/pages/orders/accepts/self_emissions/Show'

/** 受注 自己運搬編集 */
import DriverOrderAcceptSelfEmissionEdit from '../driver/pages/orders/accepts/self_emissions/Edit'

/** 受注 自己運搬複写 */
import DriverOrderAcceptSelfEmissionDuplicate from '../driver/pages/orders/accepts/self_emissions/Duplicate'


/** 受注 他社運搬新規 */
import DriverOrderAcceptProxyRequestNew from '../driver/pages/orders/accepts/proxy_requests/New'

/** 受注 他社運搬詳細 */
import DriverOrderAcceptProxyRequest from '../driver/pages/orders/accepts/proxy_requests/Show'

/** 受注 他社運搬編集 */
import DriverOrderAcceptProxyRequestEdit from '../driver/pages/orders/accepts/proxy_requests/Edit'

/** 受注 他社運搬複写 */
import DriverOrderAcceptProxyRequestDuplicate from '../driver/pages/orders/accepts/proxy_requests/Duplicate'

/** 受注 一般廃棄物新規 */
import DriverOrderAcceptGeneralNew from '../driver/pages/orders/accepts/generals/New'

/** 受注 一般廃棄物詳細 */
import DriverOrderAcceptGeneral from '../driver/pages/orders/accepts/generals/Show'

/** 受注 一般廃棄物編集 */
import DriverOrderAcceptGeneralEdit from '../driver/pages/orders/accepts/generals/Edit'

/** 受注 一般廃棄物複写 */
import DriverOrderAcceptGeneralDuplicate from '../driver/pages/orders/accepts/generals/Duplicate'




/** 受注 搬入新規 */
import DriverOrderAcceptCarryInNew from '../driver/pages/orders/accepts/carry_in/New'

/** 受注 搬入複写新規 */
import DriverOrderAcceptCarryinDuplicate from '../driver/pages/orders/accepts/carry_in/Duplicate'

/** 受注 搬入詳細 */
import DriverOrderAcceptCarryIn from '../driver/pages/orders/accepts/carry_in/Show'

/** 受注 搬入予定からの受注 */
import DriverOrderAcceptCarryInRegistrationEdit from '../driver/pages/orders/accepts/carry_in/registrations/Edit'

/** 受注 引取新規 */
import DriverOrderAcceptPickupNew from '../driver/pages/orders/accepts/pickup/New'

/** 受注 引取複写新規 */
import DriverOrderAcceptPickupDuplicate from '../driver/pages/orders/accepts/pickup/Duplicate'

/** 受注 引取詳細 */
import DriverOrderAcceptPickup from '../driver/pages/orders/accepts/pickup/Show'

/** 受注 積替運搬からの受注 */
import DriverOrderAcceptPickupRegistrationEdit from '../driver/pages/orders/accepts/pickup/registrations/Edit'

/** 受注 csv取込 */
import DriverOrderAcceptCsvImport from '../driver/pages/orders/accepts/Import'

/** 受発注 発注（積替・搬入）一覧 */
import DriverOrderRequests from '../driver/pages/orders/requests/Index'

/** 受発注 発注（積替・搬入）搬入予約編集 */
import DriverOrderRequestCarryInEdit from '../driver/pages/orders/requests/carry_in/Edit'

/** 受発注 発注（積替・搬入）搬入予約参照 */
import DriverOrderRequestCarryIn from '../driver/pages/orders/requests/carry_in/Show'

/** 受発注 発注（積替・搬入）積替運搬編集 */
import DriverOrderRequestPickupEdit from '../driver/pages/orders/requests/pickup/Edit'

/** 受発注 発注（積替・搬入）積替運搬参照 */
import DriverOrderRequestPickup from '../driver/pages/orders/requests/pickup/Show'

/** 処分場受入 一覧 */
import DriverAcceptances from '../driver/pages/acceptances/Index'

/** 処分場受入 詳細 */
import DriverAcceptance from '../driver/pages/acceptances/Show'

/** マニフェスト管理 */
import DriverManifestManagements from '../driver/pages/manifest/managements/Index'

/** マニフェスト詳細 */
import DriverManifestManagement from '../driver/pages/manifest/managements/Show'

/** マニフェスト管理　新規登録 */
import DriverManifestManagementNew from '../driver/pages/manifest/managements/New'

/** マニフェスト管理　編集 */
import DriverManifestManagementEdit from '../driver/pages/manifest/managements/Edit'

import DriverManifestManagementDuplicate from '../driver/pages/manifest/managements/Duplicate'

/** マニフェスト管理　csv取込 */
import DriverManifestManagementCsvImport from '../driver/pages/manifest/managements/Import'

/** １次２次紐付け */
import DriverManifestLinkages from '../driver/pages/manifest/linkages/Index'

/** １次２次紐付け 新規 */
import DriverManifestLinkageNew from '../driver/pages/manifest/linkages/New'

/** JWNETデータ取込 */
import DriverTransferManifests from "../driver/pages/transfers/Index.vue";

/** 受渡確認票 */
import DriverOrderConfirmationSlips from '../driver/pages/orders/confirmation_slips/Index'

/** 受渡確認票 */
import DriverManifestConfirmationSlips from '../driver/pages/manifest/confirmation_slips/Index'

/** 一覧表 */
import DriverOrderConfirmationLists from '../driver/pages/orders/confirmation_lists/Index'

/** 一覧表 */
import DriverManifestConfirmationLists from '../driver/pages/manifest/confirmation_lists/Index'

/** 利用申込書(C) */
import DriverJwnetJoinApplicationForms from '../driver/pages/masters/tenants/jwnet_join_application_forms/Show'

/** 利用申込書(A/B) */
import DriverJwnetEdiApplicationForms from '../driver/pages/masters/tenants/jwnet_edi_application_forms/Show'

/** 配車計画 */
import DriverAllocations from '../driver/pages/allocations/Index'

/** ドライバースケジュール */
import DriverSchedules from '../driver/pages/driver_schedules/Index';

/** JWNET（WEB）データ取込 */
import DriverTransfers from '../driver/pages/transfers/Index'

/** JWNET（WEB）データ取込詳細 */
import DriverTransfer from '../driver/pages/transfers/Show'

/** データ集計 マニフェスト集計出力 */
import DriverReportManifests from '../driver/pages/reports/manifests/Index'

/** データ集計 交付等状況報告出力 */
import DriverReportIssuanceStatuses from  '../driver/pages/reports/issuance_statuses/Index'

/** データ集計 実績報告書用データ出力 */
import DriverReportGovernments from '../driver/pages/reports/governments/Index'

/** お知らせ */
import DriverNotifications from '../driver/pages/notifications/Index'

/** 取引管理 */
import DriverSalesTransactions from '../driver/pages/sales/transactions/Index'
import DriverSalesTransactionNew from '../driver/pages/sales/transactions/New'

import DriverSalesTransaction from '../driver/pages/sales/transactions/Show'
import DriverSalesTransactionEdit from '../driver/pages/sales/transactions/Edit'
import DriverSalesTransactionDuplicate from '../driver/pages/sales/transactions/Duplicate'

/** 請求管理 */
import DriverSalesRequests from '../driver/pages/sales/requests/Index'
import DriverSalesRequest from '../driver/pages/sales/requests/Show'

/** freee請求管理 */
import DriverSalesFreeeTransactions from '../driver/pages/sales/freee_transactions/Index'

/** テナント */
import DriverMasterTenant from '../driver/pages/masters/tenants/Show'
import DriverMasterTenantEdit from '../driver/pages/masters/tenants/Edit'

/** 外部連携編集画面 */
import DriverMasterTenantProvider from '../driver/pages/masters/tenants/providers/Index.vue'

/** 外部連携コールバック */
import DriverProviderCallback from '../driver/pages/providers/callback/Index.vue'

/** freee事業所選択 */
import DriverProviderFreeeCompany from '../driver/pages/providers/freee/companies/Index.vue'

/** ユーザー一覧 */
import DriverMasterUsers from '../driver/pages/masters/users/Index'
/** ユーザー詳細 */
import DriverMasterUser from '../driver/pages/masters/users/Show'
/** ユーザー新規 */
import DriverMasterUserNew from '../driver/pages/masters/users/New'
/** ユーザー編集 */
import DriverMasterUserEdit from '../driver/pages/masters/users/Edit'
/** ユーザーCSV取込 */
import DriverMasterUserCsvImport from '../driver/pages/masters/users/Import'

/** ユーザー招待 */
import DriverInvitations from '../driver/pages/invitations/Index'

/** 排出事業者一覧 */
import DriverMasterEmissions from '../driver/pages/masters/emissions/Index'
/** 排出事業者新規 */
import DriverMasterEmissionNew from '../driver/pages/masters/emissions/New'
/** 排出事業者詳細 */
import DriverMasterEmission from '../driver/pages/masters/emissions/Show'
/** 排出事業者更新 */
import DriverMasterEmissionEdit from '../driver/pages/masters/emissions/Edit'
/** 排出事業者CSV取込 */
import DriverMasterEmissionCsvImport from '../driver/pages/masters/emissions/EmissionImport'
/** 排出事業場CSV取込 */
import DriverMasterEmissionLocationCsvImport from '../driver/pages/masters/emissions/LocationImport'

/** 請求先一覧 */
import DriverMasterBillingAddresses from '../driver/pages/masters/billing_addresses/Index'

/** 請求先CSV取込 */
import DriverMasterBillingAddressCsvImport from '../driver/pages/masters/billing_addresses/Import'

/** 請求先新規 */
import DriverMasterBillingAddressNew from '../driver/pages/masters/billing_addresses/New'

/** 請求先編集 */
import DriverMasterBillingAddressEdit from '../driver/pages/masters/billing_addresses/Edit'

/** 請求先詳細 */
import DriverMasterBillingAddress from '../driver/pages/masters/billing_addresses/Show'

/** 収集運搬業者  */
import DriverMasterTransports from '../driver/pages/masters/transports/Index'
import DriverMasterTransport from '../driver/pages/masters/transports/Show'
import DriverMasterTransportCsvImport from '@/driver/pages/masters/transports/TransportImport'

/** 処分業者 */
import DriverMasterDisposers from '../driver/pages/masters/disposers/Index'
import DriverMasterDisposer from '../driver/pages/masters/disposers/Show'
import DriverMasterDisposerCsvImport from '@/driver/pages/masters/disposers/DisposerImport'

/** 最終処分場 */
import DriverMasterFinalDisposalSites from '../driver/pages/masters/final_disposal_sites/Index'
import DriverMasterFinalDisposalSiteNew from '../driver/pages/masters/final_disposal_sites/New'
import DriverMasterFinalDisposalSiteEdit from '../driver/pages/masters/final_disposal_sites/Edit'
import DriverMasterFinalDisposalSite from '../driver/pages/masters/final_disposal_sites/Show'

/** 公共積替 */
import DriverMasterPublicPlaces from '../driver/pages/masters/public_places/Index'
import DriverMasterPublicPlaceNew from '../driver/pages/masters/public_places/New'
import DriverMasterPublicPlace from '../driver/pages/masters/public_places/Show'
import DriverMasterPublicPlaceEdit from '../driver/pages/masters/public_places/Edit'

/** JWNET未加入業者一覧 */
import DriverMasterNonSubscribeTraders from '../driver/pages/masters/non_subscribe_traders/Index'
/** JWNET未加入業者新規 */
import DriverMasterNonSubscribeTraderNew  from '../driver/pages/masters/non_subscribe_traders/New'
/** JWNET未加入業者詳細 */
import DriverMasterNonSubscribeTrader from '../driver/pages/masters/non_subscribe_traders/Show'
/** JWNET未加入業者更新 */
import DriverMasterNonSubscribeTraderEdit from '../driver/pages/masters/non_subscribe_traders/Edit'

/** 報告不要業者一覧 */
import DriverMasterNonReportingTraders from '../driver/pages/masters/non_reporting_traders/Index'
/** 報告不要業者新規 */
import DriverMasterNonReportingTraderNew from '../driver/pages/masters/non_reporting_traders/New'
/** 報告不要業者詳細 */
import DriverMasterNonReportingTrader from '../driver/pages/masters/non_reporting_traders/Show'
/** 報告不要業者更新 */
import DriverMasterNonReportingTraderEdit from '../driver/pages/masters/non_reporting_traders/Edit'

/** 一般廃棄物処分業者 */
import DriverMasterGeneralWasteDisposals    from '../driver/pages/masters/general_waste_disposals/Index.vue'
import DriverMasterGeneralWasteDisposal     from '../driver/pages/masters/general_waste_disposals/Show.vue'
import DriverMasterGeneralWasteDisposalNew  from '../driver/pages/masters/general_waste_disposals/New.vue'
import DriverMasterGeneralWasteDisposalEdit from '../driver/pages/masters/general_waste_disposals/Edit.vue'

/** 品目 */
import DriverMasterItems from '../driver/pages/masters/items/Index'
import DriverMasterItemEdit from '../driver/pages/masters/items/Edit'

/** 一般廃棄物品目 */
import DriverMasterGeneralItems from '../driver/pages/masters/general_items/Index'

/** ルート */
import DriverMasterTransportRoutes from '../driver/pages/masters/transport_routes/Index'
import DriverMasterTransportRoute from '../driver/pages/masters/transport_routes/Show'
import DriverMasterTransportRouteNew from '../driver/pages/masters/transport_routes/New'
import DriverMasterTransportRouteEdit from '../driver/pages/masters/transport_routes/Edit'

/** 車両一覧 */
import DriverMasterVehicles from '../driver/pages/masters/vehicles/Index'
/** 車両CSV取込 */
import DriverMasterVehicleCsvImport from '../driver/pages/masters/vehicles/Import'


import DriverImports from '../driver/pages/import/Index'

/** 売上品目単価マスタ */
import DriverMasterSalesItemPrices from '../driver/pages/masters/sales_item_prices/Index'
/** 売上品目単価CSV取込 */
import DriverMasterSalesItemPriceCsvImport from '../driver/pages/masters/sales_item_prices/Import'

/** 品目単位 */
import DriverMasterSalesItemUnits from '../driver/pages/masters/sales_item_units/Index'

/** 取引先品目単価マスタ（事業者別） */
import DriverMasterSupplierSalesItemPrices from '../driver/pages/masters/suppliers/sales_item_prices/Index'

/** 行政報告換算係数 */
import DriverMasterConversionFactorDetails from '../driver/pages/masters/conversion_factor_details/Index';

/** カスタム表示ラベル */
import DriverMasterCustomLabel from '../driver/pages/masters/custom_labels/Show'

/** カスタム表示ラベル編集 */
import DriverMasterCustomLabelEdit from '../driver/pages/masters/custom_labels/Edit'

/** 処分方法 */
import DriverMasterRecycleDisposalMethods from '../driver/pages/masters/recycle_disposal_methods/Index.vue'
/** 処分方法 */
import DriverMasterRecycleDisposalMethodsCsvImport from '../driver/pages/masters/recycle_disposal_methods/Import'

/** 処理後物 */
import DriverMasterRecycleDisposedItems from '../driver/pages/masters/recycle_disposed_items/Index.vue'
/** 処理後物CSV取込 */
import DriverMasterRecycleDisposedItemCsvImport from '../driver/pages/masters/recycle_disposed_items/Import'

/** 再資源化等パターン */
import DriverMasterRecycleDisposalPatterns from '../driver/pages/masters/recycle_disposal_patterns/Index.vue'

/** 処分場処理方法 新規 */
import DriverMasterMethodNew from '../driver/pages/masters/recycle_disposal_patterns/methods/New.vue'
/** 処分場処理方法 編集 */
import DriverMasterMethodEdit from '../driver/pages/masters/recycle_disposal_patterns/methods/Edit.vue'
/** 処分場処理方法 詳細 */
import DriverMasterMethod from '../driver/pages/masters/recycle_disposal_patterns/methods/Show.vue'

/** 処理フロー 新規 */
import DriverMasterFlowNew from '../driver/pages/masters/recycle_disposal_patterns/flows/New.vue'
/** 処理フロー 編集 */
import DriverMasterFlowEdit from '../driver/pages/masters/recycle_disposal_patterns/flows/Edit.vue'
/** 処理フロー 詳細 */
import DriverMasterFlow from '../driver/pages/masters/recycle_disposal_patterns/flows/Show.vue'

/** 再資源化換算係数 */
import DriverMasterRecycleConversionFactorDetails from '../driver/pages/masters/recycle_conversion_factor_details/Index.vue'

export default {
  path: '/driver',
  component: DriverApp,
  children: [
    { path: '/driver/', name: 'DriverSessions', component: DriverSessions, meta: { siteSubTitle: 'ログイン', isPublic: true } },

    { path: '/driver/forget', name: 'DriverForget', component: DriverForget, meta: { isPublic: true } },
    { path: '/driver/forget/:token/edit', name: 'DriverForgetEdit', component: DriverForgetEdit, meta: { isPublic: true } },
    { path: '/driver/forget/completed', name: 'DriverForgetCompleted', component: DriverForgetCompleted, meta: { isPublic: true } },

    { path: '/driver/invitations/:token', name: 'DriverInvitations', component: DriverInvitations, meta: { isPublic: true } },

    { path: '/driver/home', name: 'DriverDashboard', component: DriverDashboard, meta: {} },

    { path: '/driver/initial_password/edit', name: 'DriverInitialPasswordEdit', component: DriverInitialPasswordEdit, meta: {} },

    { path: '/driver/orders/accepts', name: 'DriverOrderAccepts', component: DriverOrderAccepts, meta: {} },

    { path: "/driver/masters/tenants/providers/:provider", name: "DriverMasterTenantProvider", component: DriverMasterTenantProvider, meta: {} },

    { path: "/driver/providers/:provider/callback", name: "DriverProviderCallback", component: DriverProviderCallback, meta: {} },

    { path: "/driver/providers/freee/companies", name: "DriverProviderFreeeCompany", component: DriverProviderFreeeCompany, meta: {} },

    { path: "/driver/orders/accepts/self_emissions/new", name: "DriverOrderAcceptSelfEmissionNew", component: DriverOrderAcceptSelfEmissionNew, meta: {} },
    { path: '/driver/orders/accepts/self_emissions/:id', name: 'DriverOrderAcceptSelfEmission', component: DriverOrderAcceptSelfEmission, meta: {} },
    { path: "/driver/orders/accepts/self_emissions/:id/edit", name: "DriverOrderAcceptSelfEmissionEdit", component: DriverOrderAcceptSelfEmissionEdit, meta: {} },
    { path: '/driver/orders/accepts/self_emissions/:duplicate_id/duplicate', name: 'DriverOrderAcceptSelfEmissionDuplicate', component: DriverOrderAcceptSelfEmissionDuplicate, meta: {} },

    { path: "/driver/orders/accepts/proxy_requests/new", name: "DriverOrderAcceptProxyRequestNew", component: DriverOrderAcceptProxyRequestNew, meta: {} },
    { path: '/driver/orders/accepts/proxy_requests/:id', name: 'DriverOrderAcceptProxyRequest', component: DriverOrderAcceptProxyRequest, meta: {} },
    { path: "/driver/orders/accepts/proxy_requests/:id/edit", name: "DriverOrderAcceptProxyRequestEdit", component: DriverOrderAcceptProxyRequestEdit, meta: {} },
    { path: '/driver/orders/accepts/proxy_requests/:duplicate_id/duplicate', name: 'DriverOrderAcceptProxyRequestDuplicate', component: DriverOrderAcceptProxyRequestDuplicate, meta: {} },

    { path: "/driver/orders/accepts/generals/new", name: "DriverOrderAcceptGeneralNew", component: DriverOrderAcceptGeneralNew, meta: {} },
    { path: '/driver/orders/accepts/generals/:id', name: 'DriverOrderAcceptGeneral', component: DriverOrderAcceptGeneral, meta: {} },
    { path: "/driver/orders/accepts/generals/:id/edit", name: "DriverOrderAcceptGeneralEdit", component: DriverOrderAcceptGeneralEdit, meta: {} },
    { path: '/driver/orders/accepts/generals/:duplicate_id/duplicate', name: 'DriverOrderAcceptGeneralDuplicate', component: DriverOrderAcceptGeneralDuplicate, meta: {} },

    { path: '/driver/orders/accepts/collections/new', name: 'DriverOrderAcceptCollectionNew', component: DriverOrderAcceptCollectionNew, meta: {} },
    { path: '/driver/orders/accepts/collections/:id', name: 'DriverOrderAcceptCollection', component: DriverOrderAcceptCollection, meta: {} },
    { path: '/driver/orders/accepts/collections/:id/edit', name: 'DriverOrderAcceptCollectionEdit', component: DriverOrderAcceptCollectionEdit, meta: {} },
    { path: '/driver/orders/accepts/collections/:duplicate_id/duplicate', name: 'DriverOrderAcceptCollectionDuplicate', component: DriverOrderAcceptCollectionDuplicate, meta: {} },
    { path: '/driver/orders/accepts/collections/:id/registrations', name: 'DriverOrderAcceptCollectionRegistrationEdit', component: DriverOrderAcceptCollectionRegistrationEdit, meta: {} },
    { path: "/driver/orders/accepts/self_emissions/:id/registrations", name: "DriverOrderAcceptSelfEmissionRegistrationEdit", component: DriverOrderAcceptSelfEmissionRegistrationEdit, meta: {} },

    { path: '/driver/orders/accepts/carry_ins/new', name: 'DriverOrderAcceptCarryInNew', component: DriverOrderAcceptCarryInNew, meta: {} },
    { path: '/driver/orders/accepts/carry_ins/:id', name: 'DriverOrderAcceptCarryIn', component: DriverOrderAcceptCarryIn, meta: {} },
    { path: '/driver/orders/accepts/carry_ins/:duplicate_id/duplicate', name: 'DriverOrderAcceptCarryinDuplicate', component: DriverOrderAcceptCarryinDuplicate, meta: {} },
    { path: '/driver/orders/accepts/carry_ins/:id/registrations', name: 'DriverOrderAcceptCarryInRegistrationEdit', component: DriverOrderAcceptCarryInRegistrationEdit, meta: {} },

    { path: '/driver/orders/accepts/pickups/new', name: 'DriverOrderAcceptPickupNew', component: DriverOrderAcceptPickupNew, meta: {} },
    { path: '/driver/orders/accepts/pickups/:id', name: 'DriverOrderAcceptPickup', component: DriverOrderAcceptPickup, meta: {} },
    { path: '/driver/orders/accepts/pickups/:duplicate_id/duplicate', name: 'DriverOrderAcceptPickupDuplicate', component: DriverOrderAcceptPickupDuplicate, meta: {} },
    { path: '/driver/orders/accepts/pickups/:id/registrations', name: 'DriverOrderAcceptPickupRegistrationEdit', component: DriverOrderAcceptPickupRegistrationEdit, meta: {} },
    { path: '/driver/orders/accepts/import', name: 'DriverOrderAcceptCsvImport', component: DriverOrderAcceptCsvImport, meta: {} },

    { path: '/driver/orders/requests', name: 'DriverOrderRequests', component: DriverOrderRequests, meta: {} },
    { path: '/driver/orders/requests/carry_in/:id/edit', name: 'DriverOrderRequestCarryInEdit', component: DriverOrderRequestCarryInEdit, meta: {} },
    { path: '/driver/orders/requests/carry_in/:id', name: 'DriverOrderRequestCarryIn', component: DriverOrderRequestCarryIn, meta: {} },
    { path: '/driver/orders/requests/pickup/:id/edit', name: 'DriverOrderRequestPickupEdit', component: DriverOrderRequestPickupEdit, meta: {} },
    { path: '/driver/orders/requests/pickup/:id', name: 'DriverOrderRequestPickup', component: DriverOrderRequestPickup, meta: {} },

    { path: '/driver/acceptances', name: 'DriverAcceptances', component: DriverAcceptances },
    { path: '/driver/acceptances/:id', name: 'DriverAcceptance', component: DriverAcceptance },

    { path: "/driver/transfers", name: "DriverTransferManifests", component: DriverTransferManifests, meta: { requiresAuth: false }},

    { path: '/driver/manifest/managements', name: 'DriverManifestManagements', component: DriverManifestManagements, meta: {} },
    { path: '/driver/manifest/managements/:level/new', name: 'DriverManifestManagementNew', component: DriverManifestManagementNew, meta: {} },
    { path: '/driver/manifest/managements/import', name: 'DriverManifestManagementCsvImport', component: DriverManifestManagementCsvImport, meta: {} },
    { path: '/driver/manifest/managements/:id/edit', name: 'DriverManifestManagementEdit', component: DriverManifestManagementEdit, meta: {} },
    { path: '/driver/manifest/managements/:id', name: 'DriverManifestManagement', component: DriverManifestManagement, meta: {} },
    { path: '/driver/manifest/managements/:duplicate_id/duplicate', name: 'DriverManifestManagementDuplicate', component: DriverManifestManagementDuplicate, meta: {} },

    { path: '/driver/manifest/linkages', name: 'DriverManifestLinkages', component: DriverManifestLinkages, meta: {} },
    { path: '/driver/manifest/linkages/new', name: 'DriverManifestLinkageNew', component: DriverManifestLinkageNew, meta: {} },

    { path: '/driver/orders/confirmation_slips', name: 'DriverOrderConfirmationSlips', component: DriverOrderConfirmationSlips, meta: {} },
    { path: '/driver/manifest/confirmation_slips', name: 'DriverManifestConfirmationSlips', component: DriverManifestConfirmationSlips, meta: {} },
    { path: '/driver/orders/confirmation_lists', name: 'DriverOrderConfirmationLists', component: DriverOrderConfirmationLists, meta: {} },
    { path: '/driver/manifest/confirmation_lists', name: 'DriverManifestConfirmationLists', component: DriverManifestConfirmationLists, meta: {} },

    { path: '/driver/masters/tenants/jwnet_join_application_forms', name: 'DriverJwnetJoinApplicationForms', component: DriverJwnetJoinApplicationForms, meta: {} },
    { path: '/driver/masters/tenants/jwnet_edi_application_forms', name: 'DriverJwnetEdiApplicationForms', component: DriverJwnetEdiApplicationForms, meta: {} },

    { path: '/driver/allocations', name: 'DriverAllocations', component: DriverAllocations, meta: {} },

    { path: '/driver/driver_schedules', name: 'DriverSchedules', component: DriverSchedules, meta: {} },

    // { path: '/driver/emissions', name: 'DriverEmissions', component: DriverEmissions, meta: {} },
    { path: '/driver/transfers', name: 'DriverTransfers', component: DriverTransfers, meta: {} },
    { path: '/driver/transfers/:id', name: 'DriverTransfer', component: DriverTransfer, meta: {} },

    { path: '/driver/reports/manifests', name: 'DriverReportManifests', component: DriverReportManifests, meta: {} },
    { path: '/driver/reports/issuance_statuses', name: 'DriverReportIssuanceStatuses', component: DriverReportIssuanceStatuses, meta: {} },
    { path: '/driver/reports/governments', name: 'DriverReportGovernments', component: DriverReportGovernments, meta: {} },

    { path: '/driver/notifications', name: 'DriverNotifications', component: DriverNotifications, meta: {} },

    { path: '/driver/sales/transactions', name: 'DriverSalesTransactions', component: DriverSalesTransactions, meta: {} },
    { path: '/driver/sales/transactions/new', name: 'DriverSalesTransactionNew', component: DriverSalesTransactionNew, meta: {} },
    { path: '/driver/sales/transactions/:id', name: 'DriverSalesTransaction', component: DriverSalesTransaction, meta: {} },
    { path: '/driver/sales/transactions/:id/edit', name: 'DriverSalesTransactionEdit', component: DriverSalesTransactionEdit, meta: {} },
    { path: '/driver/sales/transactions/:duplicate_id/duplicate', name: 'DriverSalesTransactionDuplicate', component: DriverSalesTransactionDuplicate, meta: {} },

    { path: '/driver/sales/requests', name: 'DriverSalesRequests', component: DriverSalesRequests, meta: {} },
    { path: '/driver/sales/requests/:id', name: 'DriverSalesRequest', component: DriverSalesRequest, meta: {} },

    { path: '/driver/sales/freee_transactions', name: 'DriverSalesFreeeTransactions', component: DriverSalesFreeeTransactions, meta: {} },

    { path: '/driver/masters/tenants', name: 'DriverMasterTenant', component: DriverMasterTenant, meta: {} },
    { path: '/driver/masters/tenants/edit', name: 'DriverMasterTenantEdit', component: DriverMasterTenantEdit, meta: {} },

    { path: '/driver/masters/users', name: 'DriverMasterUsers', component: DriverMasterUsers, meta: {} },
    { path: '/driver/masters/users/new', name: 'DriverMasterUserNew', component: DriverMasterUserNew, meta: {} },
    { path: '/driver/masters/users/import', name: 'DriverMasterUserCsvImport', component: DriverMasterUserCsvImport, meta: {} },
    { path: '/driver/masters/users/:id', name: 'DriverMasterUser', component: DriverMasterUser, meta: {} },
    { path: '/driver/masters/users/:id/edit', name: 'DriverMasterUserEdit', component: DriverMasterUserEdit, meta: {} },

    { path: '/driver/masters/emissions', name: 'DriverMasterEmissions', component: DriverMasterEmissions, meta: {} },
    { path: '/driver/masters/emissions/new', name: 'DriverMasterEmissionNew', component: DriverMasterEmissionNew, meta: {} },
    { path: '/driver/masters/emissions/import', name: 'DriverMasterEmissionCsvImport', component: DriverMasterEmissionCsvImport, meta: {} },
    { path: '/driver/masters/emissions/locations/import', name: 'DriverMasterEmissionLocationCsvImport', component: DriverMasterEmissionLocationCsvImport, meta: {} },
    { path: '/driver/masters/emissions/:id', name: 'DriverMasterEmission', component: DriverMasterEmission, meta: {} },
    { path: '/driver/masters/emissions/:id/edit', name: 'DriverMasterEmissionEdit', component: DriverMasterEmissionEdit, meta: {} },

    { path: '/driver/masters/billing_addresses', name: 'DriverMasterBillingAddresses', component: DriverMasterBillingAddresses, meta: {} },
    { path: '/driver/masters/billing_addresses/import', name: 'DriverMasterBillingAddressCsvImport', component: DriverMasterBillingAddressCsvImport, meta: {} },
    { path: '/driver/masters/billing_addresses/new', name: 'DriverMasterBillingAddressNew', component: DriverMasterBillingAddressNew, meta: {} },
    { path: '/driver/masters/billing_addresses/:id/edit', name: 'DriverMasterBillingAddressEdit', component: DriverMasterBillingAddressEdit, meta: {} },
    { path: '/driver/masters/billing_addresses/:id', name: 'DriverMasterBillingAddress', component: DriverMasterBillingAddress, meta: {} },

    { path: '/driver/masters/transports', name: 'DriverMasterTransports', component: DriverMasterTransports, meta: {} },
    { path: '/driver/masters/transports/import', name: 'DriverMasterTransportCsvImport', component: DriverMasterTransportCsvImport },
    { path: '/driver/masters/transports/:id', name: 'DriverMasterTransport', component: DriverMasterTransport, meta: {} },

    { path: '/driver/masters/disposers', name: 'DriverMasterDisposers', component: DriverMasterDisposers, meta: {} },
    { path: '/driver/masters/disposers/import', name: 'DriverMasterDisposerCsvImport', component: DriverMasterDisposerCsvImport },
    { path: '/driver/masters/disposers/:id', name: 'DriverMasterDisposer', component: DriverMasterDisposer, meta: {} },

    { path: '/driver/masters/final_disposal_sites', name: 'DriverMasterFinalDisposalSites', component: DriverMasterFinalDisposalSites, meta: {} },
    { path: '/driver/masters/final_disposal_sites/new', name: 'DriverMasterFinalDisposalSiteNew', component: DriverMasterFinalDisposalSiteNew, meta: {} },
    { path: '/driver/masters/final_disposal_sites/:id/edit', name: 'DriverMasterFinalDisposalSiteEdit', component: DriverMasterFinalDisposalSiteEdit, meta: {} },
    { path: '/driver/masters/final_disposal_sites/:id', name: 'DriverMasterFinalDisposalSite', component: DriverMasterFinalDisposalSite, meta: {} },

    { path: '/driver/masters/public_places', name: 'DriverMasterPublicPlaces', component: DriverMasterPublicPlaces, meta: {} },
    { path: '/driver/masters/public_places/new', name: 'DriverMasterPublicPlaceNew', component: DriverMasterPublicPlaceNew, meta: {} },
    { path: '/driver/masters/public_places/:id', name: 'DriverMasterPublicPlace', component: DriverMasterPublicPlace, meta: {} },
    { path: '/driver/masters/public_places/:id/edit', name: 'DriverMasterPublicPlaceEdit', component: DriverMasterPublicPlaceEdit, meta: {} },

    { path: '/driver/masters/non_subscribe_traders', name: 'DriverMasterNonSubscribeTraders', component: DriverMasterNonSubscribeTraders, meta: {  } },
    { path: '/driver/masters/non_subscribe_traders/new', name: 'DriverMasterNonSubscribeTraderNew',  component: DriverMasterNonSubscribeTraderNew, meta: {  } },
    { path: '/driver/masters/non_subscribe_traders/:id', name: 'DriverMasterNonSubscribeTrader', component: DriverMasterNonSubscribeTrader, meta: {  } },
    { path: '/driver/masters/non_subscribe_traders/:id/edit', name: 'DriverMasterNonSubscribeTraderEdit', component: DriverMasterNonSubscribeTraderEdit, meta: {  } },

    { path: '/driver/masters/non_reporting_traders', name: 'DriverMasterNonReportingTraders', component: DriverMasterNonReportingTraders, meta: {  } },
    { path: '/driver/masters/non_reporting_traders/new', name: 'DriverMasterNonReportingTraderNew',  component: DriverMasterNonReportingTraderNew, meta: {  } },
    { path: '/driver/masters/non_reporting_traders/:id', name: 'DriverMasterNonReportingTrader', component: DriverMasterNonReportingTrader, meta: {  } },
    { path: '/driver/masters/non_reporting_traders/:id/edit', name: 'DriverMasterNonReportingTraderEdit', component: DriverMasterNonReportingTraderEdit, meta: {  } },

    { path: '/driver/masters/general_waste_disposals', name: 'DriverMasterGeneralWasteDisposals', component: DriverMasterGeneralWasteDisposals, meta: {  } },
    { path: '/driver/masters/general_waste_disposals/new', name: 'DriverMasterGeneralWasteDisposalNew',  component: DriverMasterGeneralWasteDisposalNew, meta: {  } },
    { path: '/driver/masters/general_waste_disposals/:id', name: 'DriverMasterGeneralWasteDisposal', component: DriverMasterGeneralWasteDisposal, meta: {  } },
    { path: '/driver/masters/general_waste_disposals/:id/edit', name: 'DriverMasterGeneralWasteDisposalEdit', component: DriverMasterGeneralWasteDisposalEdit, meta: {  } },

    { path: '/driver/masters/items', name: 'DriverMasterItems', component: DriverMasterItems, meta: {} },
    { path: '/driver/masters/items/:type/edit', name: 'DriverMasterItemEdit', component: DriverMasterItemEdit, meta: {} },

    { path: '/driver/masters/general_items', name: 'DriverMasterGeneralItems', component: DriverMasterGeneralItems, meta: {} },

    { path: '/driver/masters/transport_routes', name: 'DriverMasterTransportRoutes', component: DriverMasterTransportRoutes, meta: {} },
    { path: '/driver/masters/transport_routes/new', name: 'DriverMasterTransportRouteNew', component: DriverMasterTransportRouteNew, meta: {} },
    { path: '/driver/masters/transport_routes/:id', name: 'DriverMasterTransportRoute', component: DriverMasterTransportRoute, meta: {} },
    { path: '/driver/masters/transport_routes/:id/edit', name: 'DriverMasterTransportRouteEdit', component: DriverMasterTransportRouteEdit, meta: {} },

    { path: '/driver/masters/vehicles', name: 'DriverMasterVehicles', component: DriverMasterVehicles, meta: {} },
    { path: '/driver/masters/vehicles/import', name: 'DriverMasterVehicleCsvImport', component: DriverMasterVehicleCsvImport, meta: {} },

    { path: '/driver/imports', name: 'DriverImports', component: DriverImports, meta: {} },

    { path: '/driver/masters/sales_item_units', name: 'DriverMasterSalesItemUnits', component: DriverMasterSalesItemUnits, meta: {} },
    { path: '/driver/masters/sales_item_prices', name: 'DriverMasterSalesItemPrices', component: DriverMasterSalesItemPrices, meta: {} },
    { path: '/driver/masters/sales_item_prices/import', name: 'DriverMasterSalesItemPriceCsvImport', component: DriverMasterSalesItemPriceCsvImport, meta: {} },
    { path: '/driver/masters/suppliers/sales_item_prices', name: 'DriverMasterSupplierSalesItemPrices', component: DriverMasterSupplierSalesItemPrices, meta: {} },
    { path: '/driver/masters/conversion_factor_details', name: 'DriverMasterConversionFactorDetails', component: DriverMasterConversionFactorDetails, meta: {} },

    { path: '/driver/masters/custom_labels',      name: 'DriverMasterCustomLabel', component: DriverMasterCustomLabel, meta: {  } },
    { path: '/driver/masters/custom_labels/edit', name: 'DriverMasterCustomLabelEdit', component: DriverMasterCustomLabelEdit, meta: {  } },

    { path: '/driver/masters/recycle_disposal_methods', name: 'DriverMasterRecycleDisposalMethods', component: DriverMasterRecycleDisposalMethods, meta: {  } },
    { path: '/driver/masters/recycle_disposal_methods/import', name: 'DriverMasterRecycleDisposalMethodsCsvImport', component: DriverMasterRecycleDisposalMethodsCsvImport, meta: {  } },
    { path: '/driver/masters/recycle_disposed_items', name: 'DriverMasterRecycleDisposedItems', component: DriverMasterRecycleDisposedItems, meta: {  } },
    { path: '/driver/masters/recycle_disposed_items/import', name: 'DriverMasterRecycleDisposedItemCsvImport', component: DriverMasterRecycleDisposedItemCsvImport, meta: {  } },

    { path: '/driver/masters/recycle_disposal_patterns', name: 'DriverMasterRecycleDisposalPatterns', component: DriverMasterRecycleDisposalPatterns, meta: {  } },
    
    { path: '/driver/masters/recycle_disposal_patterns/methods/new', name: 'DriverMasterMethodNew', component: DriverMasterMethodNew, meta: {  } },
    { path: '/driver/masters/recycle_disposal_patterns/methods/:id', name: 'DriverMasterMethod', component: DriverMasterMethod, meta: {  } },
    { path: '/driver/masters/recycle_disposal_patterns/methods/:id/edit', name: 'DriverMasterMethodEdit', component: DriverMasterMethodEdit, meta: {  } },

    { path: '/driver/masters/recycle_disposal_patterns/flows/new', name: 'DriverMasterFlowNew', component: DriverMasterFlowNew, meta: {  } },
    { path: '/driver/masters/recycle_disposal_patterns/flows/:id', name: 'DriverMasterFlow', component: DriverMasterFlow, meta: {  } },
    { path: '/driver/masters/recycle_disposal_patterns/flows/:id/edit', name: 'DriverMasterFlowEdit', component: DriverMasterFlowEdit, meta: {  } },

    { path: '/driver/masters/recycle_conversion_factor_details', name: 'DriverMasterRecycleConversionFactorDetails', component: DriverMasterRecycleConversionFactorDetails, meta: {  } },

  ]
}
